// Feature keys del framework de rollout. El slug coincide con el nombre del build flag
// (ENABLE_MENU_V2 = flag 'menu-v2') y con feature.feature_key en el backend.
export const MENU_FEATURE_KEY = 'menu-v2';

// Impresión térmica por Web Bluetooth (PR #1031). Feature COMPLETA del framework (A/B +
// invitación + switch de versión). Particularidad vs menu-v2: las superficies de invitación
// además se gatean por COMPATIBILIDAD del dispositivo (isWebBleSupported + isSecureContext) —
// la asignación es per-comercio pero la capacidad BT es per-dispositivo; no se invita donde
// la funcionalidad no puede usarse.
export const BLE_FEATURE_KEY = 'impresion-ble';

// Registro tipado de las feature keys del rollout (SPEC-8). `FeatureKey` es el union que
// consumen la fábrica de gates y el hook base: un typo en el slug HOY compila y crea una
// feature fantasma (cache/telemetría propios, GETs 404 silenciosos) — con el union, no
// compila. Toda feature nueva se agrega AQUÍ (y su flag en los vite.config.*).
export const FEATURE_KEYS = [MENU_FEATURE_KEY, BLE_FEATURE_KEY] as const;
export type FeatureKey = (typeof FEATURE_KEYS)[number];
